import { useEffect } from "react";

export interface BreadcrumbItem {
  name: string;
  url: string; // absolute URL
}

const SCRIPT_ID = "breadcrumb-jsonld";

/**
 * Injects a BreadcrumbList JSON-LD <script> into the document head.
 * Replaces any existing one so route changes update the schema.
 */
export function useBreadcrumbSchema(items: BreadcrumbItem[]) {
  useEffect(() => {
    if (!items || items.length === 0) return;

    const schema = {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      itemListElement: items.map((item, idx) => ({
        "@type": "ListItem",
        position: idx + 1,
        name: item.name,
        item: item.url,
      })),
    };

    let el = document.getElementById(SCRIPT_ID) as HTMLScriptElement | null;
    if (!el) {
      el = document.createElement("script");
      el.type = "application/ld+json";
      el.id = SCRIPT_ID;
      document.head.appendChild(el);
    }
    el.textContent = JSON.stringify(schema);

    return () => {
      const existing = document.getElementById(SCRIPT_ID);
      if (existing) existing.remove();
    };
  }, [JSON.stringify(items)]);
}
